<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <h1>
              Example heading
              <span class="badge rounded text-white badge-primary">New</span>
            </h1>
            <h2>
              Example heading
              <span class="badge rounded text-white badge-primary">New</span>
            </h2>
            <h3>
              Example heading
              <span class="badge rounded text-white badge-primary">New</span>
            </h3>
            <h4>
              Example heading
              <span class="badge rounded text-white badge-primary">New</span>
            </h4>
            <h5>
              Example heading
              <span class="badge rounded text-white badge-primary">New</span>
            </h5>
            <h6>
              Example heading
              <span class="badge rounded text-white badge-primary">New</span>
            </h6>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Contextual variations</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <span
              class="badge p-2 badge-primary rounded text-white inline-block mb-1"
              >Primary</span
            ><br />
            <span
              class="badge p-2 badge-secondary rounded text-white inline-block mb-1"
              >Secondary</span
            ><br />
            <span
              class="badge p-2 badge-success rounded text-white inline-block mb-1"
              >Success</span
            ><br />
            <span
              class="badge p-2 badge-danger rounded text-white inline-block mb-1"
              >Danger</span
            ><br />
            <span
              class="badge p-2 badge-warning rounded text-white inline-block mb-1"
              >Warning</span
            ><br />
            <span
              class="badge p-2 badge-info rounded text-white inline-block mb-1"
              >Info</span
            ><br />
            <span
              class="badge p-2 badge-light rounded text-dark inline-block mb-1"
              >Light</span
            ><br />
            <span
              class="badge p-2 badge-dark rounded text-white inline-block mb-1"
              >Dark</span
            ><br />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Pill badges</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <span
              class="badge p-2 badge-primary rounded-full text-white inline-block mb-1"
              >Primary</span
            ><br />
            <span
              class="badge p-2 badge-secondary rounded-full text-white inline-block mb-1"
              >Secondary</span
            ><br />
            <span
              class="badge p-2 badge-success rounded-full text-white inline-block mb-1"
              >Success</span
            ><br />
            <span
              class="badge p-2 badge-danger rounded-full text-white inline-block mb-1"
              >Danger</span
            ><br />
            <span
              class="badge p-2 badge-warning rounded-full text-white inline-block mb-1"
              >Warning</span
            ><br />
            <span
              class="badge p-2 badge-info rounded-full text-white inline-block mb-1"
              >Info</span
            ><br />
            <span
              class="badge p-2 badge-light rounded-full text-dark inline-block mb-1"
              >Light</span
            ><br />
            <span
              class="badge p-2 badge-dark rounded-full text-white inline-block mb-1"
              >Dark</span
            ><br />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Link badges</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <a href="#"
              class="badge p-2 badge-primary rounded text-white inline-block mb-1"
              >Primary</a><br />
            <a href="#"
              class="badge p-2 badge-secondary rounded text-white inline-block mb-1"
              >Secondary</a
            ><br />
            <a href="#"
              class="badge p-2 badge-success rounded text-white inline-block mb-1"
              >Success</a
            ><br />
            <a href="#"
              class="badge p-2 badge-danger rounded text-white inline-block mb-1"
              >Danger</a
            ><br />
            <a href="#"
              class="badge p-2 badge-warning rounded text-white inline-block mb-1"
              >Warning</a
            ><br />
            <a href="#"
              class="badge p-2 badge-info rounded text-white inline-block mb-1"
              >Info</a
            ><br />
            <a href="#"
              class="badge p-2 badge-light rounded text-dark inline-block mb-1"
              >Light</a
            ><br />
            <a href="#"
              class="badge p-2 badge-dark rounded text-white inline-block mb-1"
              >Dark</a
            ><br />
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({}),
};
</script>